// extracted by mini-css-extract-plugin
export default {"priority":"RequestRowCells_priority__EAznC","priorityColor":"RequestRowCells_priorityColor__e40Lx"};